import React from 'react'
import CreatePetitionSuccess from '../../components/petitions/CreatePetition/CreatePetitionSuccess/CreatePetitionSuccess'

const CreatePetitionSuccessPage = () => {
  return (
    <><CreatePetitionSuccess /></>
  )
}

export default CreatePetitionSuccessPage